
import { GlobalController } from 'src/shared/global/GlobalController'
import Representative from './Representative'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'representative',
    component: Representative,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
